if (typeof Countries === 'object') {
  Countries.updateProvinceLabel = function (country, provinceLabel) {
    if (typeof country !== 'string' || !Countries[country] || !Countries[country].provinces) return;

    if (typeof provinceLabel !== 'object') {
      provinceLabel = document.getElementById('address_province_label');
      if (provinceLabel === null) return;
    }

    provinceLabel.innerHTML = Countries[country].label;
    var provinceContainer = jQuery(provinceLabel).parent();
    provinceContainer.find('select');
    provinceContainer.find('.custom-style-select-box-inner').html(Countries[country].provinces[0]);
  };
}

if (typeof Shopify.Cart === 'undefined') Shopify.Cart = {};

Shopify.Cart.ShippingCalculator = (function () {
  var config = {
    submitButton: 'Calculer les frais de livraison',
    submitButtonDisabled: 'Calcul en cours…',
    templateId: 'shipping-calculator-response-template',
    wrapperId: 'wrapper-response',
    customerIsLoggedIn: false,
    moneyFormat: '${{amount}}',
    shippingErrorTitle: 'Erreur',
    shippingUnsupportedDestination: 'Nous ne livrons pas à cette destination.',
    shippingFreeRate: 'GRATUIT'
  };

  function render(response) {
    var template = jQuery('#' + config.templateId);
    var wrapper = jQuery('#' + config.wrapperId);

    if (!template.length || !wrapper.length) return;

    _.templateSettings = {
      evaluate: /<%([\s\S]+?)%>/g,
      interpolate: /<%=([\s\S]+?)%>/g,
      escape: /<%-([\s\S]+?)%>/g
    };

    var compileTemplate = _.template(jQuery.trim(template.text()));
    var markup = compileTemplate(response);
    jQuery(markup).appendTo(wrapper);

    if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
      var currentCurrency = '';
      if (jQuery('[name=currencies]').size()) {
        currentCurrency = jQuery('[name=currencies]').val();
      } else if (jQuery('#currencies span.selected').size()) {
        currentCurrency = jQuery('#currencies span.selected').attr('data-currency');
      }

      if (currentCurrency !== '') {
        Currency.convertAll(
          shopCurrency,
          currentCurrency,
          '#wrapper-response span.money, #estimated-shipping span.money'
        );
      }
    }
  }

  function enableButtons() {
    jQuery('.get-rates').removeAttr('disabled').removeClass('disabled').val(config.submitButton);
  }

  function disableButtons() {
    jQuery('.get-rates').val(config.submitButtonDisabled).attr('disabled', 'disabled').addClass('disabled');
  }

  function getCartShippingRatesForDestination(destination) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/prepare_shipping_rates',
      data: jQuery.param({ shipping_address: destination }),
      success: pollForCartShippingRatesForDestination(destination),
      error: onError
    });
  }

  function pollForCartShippingRatesForDestination(destination) {
    return function poll() {
      jQuery.ajax('/cart/async_shipping_rates', {
        dataType: 'json',
        success: function (response, textStatus, request) {
          if (request.status === 200) {
            onCartShippingRatesUpdate(response.shipping_rates, destination);
          } else {
            setTimeout(poll, 500);
          }
        },
        error: onError
      });
    };
  }

  function fullMessagesFromErrors(errors) {
    var messages = [];
    jQuery.each(errors, function (field, fieldErrors) {
      jQuery.each(fieldErrors, function (index, message) {
        messages.push(field + ' ' + message);
      });
    });
    return messages;
  }

  function onError(request) {
    jQuery('#estimated-shipping').hide();
    jQuery('#estimated-shipping em').empty();
    enableButtons();

    var data = JSON.parse(request.responseText);
    var feedback;

    if (data.message) {
      feedback = data.message + '(' + data.status + '): ' + data.description;
    } else if (Object.prototype.hasOwnProperty.call(data, 'country')) {
      feedback = config.shippingUnsupportedDestination;
    } else {
      feedback = config.shippingErrorTitle + ' : ' + fullMessagesFromErrors(data).join('; ') + '.';
    }

    render({ rates: [], errorFeedback: feedback, success: false });
    jQuery('#' + config.wrapperId).show();
  }

  function onCartShippingRatesUpdate(rates, destination) {
    enableButtons();
    var address = '';

    if (destination.zip) address += destination.zip + ', ';
    if (destination.province) address += destination.province + ', ';
    address += destination.country;

    if (rates.length) {
      if (rates[0].price === '0.00') {
        jQuery('#estimated-shipping em').html(config.shippingFreeRate);
      } else {
        jQuery('#estimated-shipping em').html(formatRate(rates[0].price));
      }

      for (var index = 0; index < rates.length; index++) {
        rates[index].price = formatRate(rates[index].price);
      }
    }

    render({ rates: rates, address: address, success: true });
    jQuery('#' + config.wrapperId + ', #estimated-shipping').fadeIn();
  }

  function defaultValue(value, fallback) {
    return typeof value === 'undefined' ? fallback : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultValue(precision, 2);
    thousands = defaultValue(thousands, ',');
    decimal = defaultValue(decimal, '.');

    if (isNaN(number) || number === null) return 0;

    number = (number / 100).toFixed(precision);
    var parts = number.split('.');
    var amount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return amount + cents;
  }

  function formatRate(rate) {
    if (typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(rate, config.moneyFormat);
    if (typeof rate === 'string') rate = rate.replace('.', '');

    var formattedRate = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var format = config.moneyFormat;
    var placeholder = format.match(placeholderRegex)[1];

    switch (placeholder) {
      case 'amount':
        formattedRate = formatWithDelimiters(rate, 2);
        break;
      case 'amount_no_decimals':
        formattedRate = formatWithDelimiters(rate, 0);
        break;
      case 'amount_with_comma_separator':
        formattedRate = formatWithDelimiters(rate, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formattedRate = formatWithDelimiters(rate, 0, '.', ',');
        break;
    }

    return format.replace(placeholderRegex, formattedRate);
  }

  function init() {
    new Shopify.CountryProvinceSelector('address_country', 'address_province', {
      hideElement: 'address_province_container'
    });

    var country = jQuery('#address_country');
    var provinceLabel = jQuery('#address_province_label').get(0);

    if (typeof Countries !== 'undefined') {
      Countries.updateProvinceLabel(country.val(), provinceLabel);
      country.change(function () {
        Countries.updateProvinceLabel(country.val(), provinceLabel);
      });
    }

    jQuery('.get-rates').click(function () {
      disableButtons();
      jQuery('#' + config.wrapperId).empty().hide();

      var destination = {
        zip: jQuery('#address_zip').val() || '',
        country: jQuery('#address_country').val() || '',
        province: jQuery('#address_province').val() || ''
      };

      getCartShippingRatesForDestination(destination);
    });

    if (config.customerIsLoggedIn) jQuery('.get-rates:eq(0)').trigger('click');
  }

  return {
    show: function (options) {
      options = options || {};
      jQuery.extend(config, options);
      jQuery(function () {
        init();
      });
    },
    getConfig: function () {
      return config;
    },
    formatRate: function (rate) {
      return formatRate(rate);
    }
  };
})();
